import {createAction} from 'redux-actions';

export const GLOBAL_RESET_ACTION = 'GLOBAL_RESET_ACTION';

export function globalResetAll() {
    return createAction(GLOBAL_RESET_ACTION)();
}
